export enum TextType {
	MESH = 'mesh',
	FLAT = 'flat',
	LINE = 'line',
	STROKE = 'stroke',
}
export const TEXT_TYPES: Array<TextType> = [TextType.MESH, TextType.FLAT, TextType.LINE, TextType.STROKE];
